import{Button} from 'react-bootstrap';

export default function BotonCustom({text,tipo}){

  const colorButton =()=>{
  switch(tipo){
    case 'blue': return 'b-custom b-custom-blue';
    case 'pink': return 'b-custom b-custom-pink';
    default : return 'b-custom b-custom-white';
  }
  }
     return(
          <Button 
          href='/integrate-con-payfun' 
          className= {colorButton()}
          size='md'
          >
            {text}
          </Button>
        )
}

